import { z } from 'zod'
import type { LoggerConfig } from './types.js'

/**
 * Environment variable schema for logger.
 * Completely independent from global configuration.
 */
const loggerEnvSchema = z.object({
  LOG_LEVEL: z.enum(['silent', 'fatal', 'error', 'warn', 'info', 'debug', 'trace']).default('info'),
  LOG_FORMAT: z.enum(['json', 'pretty']).default('pretty'),
  LOG_FILE: z.string().optional(),
  NODE_ENV: z.string().default('development'),
  // Sentry opcional - solo se activa si DSN está definido
  SENTRY_DSN: z.string().url().optional(),
  SENTRY_SAMPLE_RATE: z.coerce.number().min(0).max(1).default(1.0)
})

export const loggerEnv = loggerEnvSchema.parse(process.env)

/**
 * Gets logger configuration from environment variables
 */
export function getLoggerConfig(): LoggerConfig {
  return {
    level: loggerEnv.LOG_LEVEL,
    format: loggerEnv.LOG_FORMAT,
    logFile: loggerEnv.LOG_FILE,
    // Sentry solo si DSN está definido
    sentry: loggerEnv.SENTRY_DSN
      ? {
          dsn: loggerEnv.SENTRY_DSN,
          environment: loggerEnv.NODE_ENV,
          sampleRate: loggerEnv.SENTRY_SAMPLE_RATE
        }
      : undefined
  }
}
